import React, { useState, useEffect } from 'react';
import { Typography, Box, Button } from '@mui/material';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from './Components/ProtectedRoute'; 
import Login from './Components/Login/Login.jsx';
import SessionManager from './Components/SessionManager/SessionManager.jsx';

//Worker
import Worker from './Components/Worker/Worker.jsx';

// Manager Components
import Managerdashboard from './Components/Manager/Managerdashboard/Managerdashboard.jsx';
import Calender from './Components/Manager/Calender/Calender.jsx';
import Team from './Components/Manager/Team/Team.jsx';
import PendingApprovals from './Components/Manager/PendingApprovals/PendingApprovals.jsx';
import Navbar1 from './Components/Manager/Navbar/Navbar1.jsx';

// HR Components
import Configuration from './Components/Hr/Configuration/Configuration.jsx';
import Hrdashboard from './Components/Hr/Dashboard/HrDashboard.jsx';
// import Employees from './Components/Hr/Employees/Employees.jsx';
import Navbar from './Components/Hr/Navbar/Navbar.jsx';
import Report from './Components/Hr/Report/Report.jsx';
import GlobalHolidayPopup from './Components/GlobalHolidayPopup/GlobalHolidayPopup.jsx';

// CEO Components
// import Attendance from './Components/Ceo/Attendance-overview/Attendance-overview.jsx';
// import Approvals from './Components/Ceo/Approvals/Approvals.jsx';
// import Leaveanalytics from './Components/Ceo/Leaveanalytics/Leaveanalytics.jsx';
// import Navbar3 from './Components/Ceo/Navbar/Navbar.jsx';

// Superadmin Components
// import Navbar4 from './Components/Superadmin/Navbar/Navbar.jsx';
// import Roleassignment from './Components/Superadmin/Roleassignment/Employees.jsx';
// import SuperadminAnalytics from './Components/Superadmin/superadmin-Analytics/Leave-Analytics.jsx';
// import SuperadminApprovals from './Components/Superadmin/Superadmin-Approvals/Compliance&Approvals.jsx';
// import SuperadminAttendance from './Components/Superadmin/superadmin-Attendance/Attendance-overview.jsx';

//Consultant
import Timesheet from './Components/Consultant/Timesheet/Timesheet.jsx';
import ConsultReport from './Components/Consultant/Report/Report.jsx';
import Hrtimesheet from './Components/Consultant/Hrtimesheet/Hrtimesheet.jsx';
import Hrempdash from './Components/Consultant/Hrempdash/Hrempdash.jsx';
// import Projectdashboard from './Components/Consultant/Project-dashboard/Project-dashboard.jsx';


//Admin
import Settings from './Components/Admin/Settings/Settings.jsx';
import Adminemployee from './Components/Admin/Employee/AdminEmployee.jsx';
import Project from './Components/Admin/Projects/Project.jsx';
import Admindashboard from './Components/Admin/Dashboard/Dashboard.jsx';
import Auditlogs from './Components/Admin/Auditlogs/Auditlogs.jsx';
import Holidays from './Components/Admin/Holidays/Holidays.jsx';
import Adminapprovals from './Components/Admin/Adminapprovals/Adminapprovals.jsx';
import Attendance from "./Components/Admin/Attendance/Attendance.jsx";
// import AttendanceEmployee from './Components/Worker/AttendanceEmployee';
import Tickets from './Components/Admin/Ticket/Tickets.jsx';
import TicketDetail from './Components/Admin/Ticket/TicketDetail.jsx'; 
import NetworkManager from './Components/Worker/NetworkManager.jsx';

// import AttendanceEmployee from './Components/Attendance/AttendanceEmployee.jsx';
// ========================================
// MAIN APP COMPONENT
// ========================================
export default function App() {
  return (
    <Router>
      {/* ── Session expiry warning + expired modals (global) ── */}
      <SessionManager />

      {/* CRITICAL FIX: Global Holiday Popup - Shows on ALL pages */}
      {/* <GlobalHolidayPopup /> */}
      
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Login />} />

        <Route path="/Worker" element={
          <ProtectedRoute allowedRoles={['Employee']}>
            <Worker />
          </ProtectedRoute>
        } />

        <Route path="/Timesheet" element={
          <ProtectedRoute allowedRoles={['Consultant']}>
            <Timesheet />
          </ProtectedRoute>
        } />

        <Route path="/ConsultReport" element={
          <ProtectedRoute allowedRoles={['Consultant']}>
            <ConsultReport />
          </ProtectedRoute>
        } />

        <Route path="/Hrtimesheet" element={
          <ProtectedRoute allowedRoles={['HR' ]}>
            <Navbar />
            <Hrtimesheet />
          </ProtectedRoute>
        } />

        <Route path="/Hrempdash" element={
          <ProtectedRoute allowedRoles={['HR' ]}>
            <Navbar /> 
            <Hrempdash />
          </ProtectedRoute>
        } />

        

        {/* Manager Routes */}
        <Route path="/managerdashboard" element={
          <ProtectedRoute allowedRoles={['Manager' ]}>
            <>
              {/* <Navbar1 /> */}
              <Managerdashboard />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/calender" element={
          <ProtectedRoute allowedRoles={['Manager']}>
            <>
              {/* <Navbar1 /> */}
              <Calender />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/team" element={
          <ProtectedRoute allowedRoles={['Manager']}>
            <>
              {/* <Navbar1 /> */}
              <Team />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/pendingapprovals" element={
          <ProtectedRoute allowedRoles={['Manager']}>
            <>
              {/* <Navbar1 /> */}
              <PendingApprovals />
            </>
          </ProtectedRoute>
        } />

        {/* HR Routes */}
        <Route path="/Hrdashboard" element={
          <ProtectedRoute allowedRoles={['HR' ]}>
            <Navbar />
            <Hrdashboard />
          </ProtectedRoute>
        } />
        
        {/* <Route path="/Employees" element={
          <ProtectedRoute allowedRoles={['HR' ,'Manager' ,'Employee' ,'CEO' ,'Superadmin','Consultant']}>
            <>
              <Navbar />
              <Employees />
            </>
          </ProtectedRoute>
        } /> */}
        
        <Route path="/Report" element={
          <ProtectedRoute allowedRoles={['HR'  ]}>
            <>
              <Navbar />
              <Report />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/Configuration" element={
          <ProtectedRoute allowedRoles={['HR' ]}>
            <>
              <Navbar />
              <Configuration />
            </>
          </ProtectedRoute>
        } />

        {/* CEO Routes */}
        {/* <Route path="/Attendance" element={
          <ProtectedRoute allowedRoles={['CEO' ,'HR' ,'Manager' ,'Employee' ,'Superadmin']}>
            <>
              <Navbar3 />
              <Attendance />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/Approvals" element={
          <ProtectedRoute allowedRoles={['CEO' ,'HR' ,'Manager' ,'Employee' ,'Superadmin']}>
            <>
              <Navbar3 />
              <Approvals />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/Leaveanalytics" element={
          <ProtectedRoute allowedRoles={['CEO'  ,'HR' ,'Manager' ,'Employee' ,'Superadmin']}>
            <>
              <Navbar3 />
              <Leaveanalytics />
            </>
          </ProtectedRoute>
        } />    */}

        {/* Superadmin Routes */}
        {/* <Route path="/Roleassignment" element={
          <ProtectedRoute allowedRoles={['Superadmin' ,'HR' ,'CEO' ,'Manager' ,'Employee']}>
            <>
              <Navbar4 />
              <Roleassignment />
            </>
          </ProtectedRoute>
        } /> */}
        
        {/* <Route path="/SuperadminApprovals" element={
          <ProtectedRoute allowedRoles={['Superadmin' ,'HR' ,'CEO' ,'Manager' ,'Employee']}>
            <>
              <Navbar4 />
              <SuperadminApprovals />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/SuperadminAnalytics" element={
          <ProtectedRoute allowedRoles={['Superadmin' ,'HR' ,'CEO' ,'Manager' ,'Employee']}>
            <>
              <Navbar4 />
              <SuperadminAnalytics />
            </>
          </ProtectedRoute>
        } />
        
        <Route path="/SuperadminAttendance" element={
          <ProtectedRoute allowedRoles={['Superadmin' ,'HR' ,'CEO' ,'Manager' ,'Employee']}>
            <>
              <Navbar4 />
              <SuperadminAttendance />
            </>
          </ProtectedRoute>
        } /> */}

        <Route path="/Settings" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Settings />
          </ProtectedRoute>
        } />

        <Route path="/Adminemployee" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Adminemployee />
          </ProtectedRoute>
        } />

        <Route path="/Project" element={
          <ProtectedRoute allowedRoles={['Superadmin']}>
            <Project />
          </ProtectedRoute>
        } />

        <Route path="/Admindashboard" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Admindashboard />
          </ProtectedRoute>
        } />

        <Route path="/Adminapprovals" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Adminapprovals />
          </ProtectedRoute>
        } />

        <Route path="/Holidays" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Holidays />
          </ProtectedRoute>
        } />

        <Route path="/Auditlogs" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Auditlogs />
          </ProtectedRoute>
        } />

        {/* Catch-all */}
        <Route path="*" element={
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            textAlign: 'center'
          }}>
            <div>
              <h1>404 - Page Not Found</h1>
              <p>The page you're looking for doesn't exist.</p>
              <a href="/" style={{ color: '#3b82f6', textDecoration: 'none' }}>
                Go to Login
              </a>
            </div>
          </div>
        } />
        <Route path="/Attendance" element={
          <ProtectedRoute allowedRoles={['Superadmin']}>
            <Attendance />
          </ProtectedRoute>
        } />
        
         <Route path="/NetworkManager" element={
          <ProtectedRoute allowedRoles={['Network Manager', 'Superadmin']}>
            <NetworkManager />
          </ProtectedRoute>
        } />

        <Route path="/Tickets" element={
          <ProtectedRoute allowedRoles={['Superadmin' ]}>
            <Tickets />
          </ProtectedRoute>
        } />

        <Route path="/Tickets/:id" element={
          <ProtectedRoute allowedRoles={['Superadmin']}>
            <TicketDetail />
          </ProtectedRoute>
        } />

       

        {/* <Route path="/MyAttendance" element={
          <ProtectedRoute allowedRoles={['Employee']}>
            <AttendanceEmployee />
          </ProtectedRoute>
        } /> */}
      </Routes>
    </Router>
  );
}